import Vue from "vue";
import store from './store';
import routes from './routes/routes';
import moment from "moment";
import _ from 'lodash';

import cities from "./cities";
import countries from "./countries";

import {Howl} from 'howler';
import Push from "push.js";


Vue.prototype.$cities= cities;
Vue.prototype.$countries= countries;

Vue.prototype.$takeArray= (array, take)=> {
    let arr= Vue.prototype.$cleanObject(array);

    if(arr.length > take) {
        arr.length= take;
    }
    return arr;
};

Vue.prototype.$messOpen= (type)=> {
    return store.commit('updateMess', type, window.scrollTo(0,0));
};


Vue.prototype.$getLocation= (location)=> {
    let country= Vue.prototype.$filterArray(Vue.prototype.$countries, location, 'key');
    if(country) {
        return country.value;
    } else {
        return location;
    }
};

Vue.prototype.$contract= {
    marketPlace: {
        abi: [{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"lotId","type":"uint256"},{"indexed":false,"internalType":"address","name":"buyer","type":"address"}],"name":"AuctionCompleted","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"sender","type":"address"},{"indexed":true,"internalType":"uint256","name":"lotId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Bid","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint8","name":"version","type":"uint8"}],"name":"Initialized","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"mintingRecordId","type":"uint256"}],"name":"MintingRecordAccepted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"mintingRecordId","type":"uint256"},{"indexed":false,"internalType":"address","name":"buyer","type":"address"}],"name":"MintingRecordCompleted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"lotId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"startTime","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"endTime","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"step","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"startBid","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"singlePaymentValue","type":"uint256"},{"indexed":false,"internalType":"address","name":"owner","type":"address"}],"name":"NewLot","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"mintingRecordId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"price","type":"uint256"},{"indexed":false,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"string","name":"tokenUri","type":"string"}],"name":"NewMintingRecord","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"saleRecordId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"price","type":"uint256"},{"indexed":false,"internalType":"address","name":"owner","type":"address"}],"name":"NewSaleRecord","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"saleRecordId","type":"uint256"},{"indexed":false,"internalType":"address","name":"buyer","type":"address"}],"name":"SaleCompleted","type":"event"},{"inputs":[{"internalType":"uint256","name":"mintingRecordId","type":"uint256"}],"name":"acceptMintingRecord","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"role","type":"string"},{"internalType":"address","name":"userAddress","type":"address"}],"name":"addRole","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"lotId","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"bid","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"saleRecordId","type":"uint256"}],"name":"buy","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"mintingRecordId","type":"uint256"}],"name":"cancelMintingRecord","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"saleRecordId","type":"uint256"}],"name":"cancelSaleRecord","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"role","type":"string"},{"internalType":"address","name":"userAddress","type":"address"}],"name":"checkRole","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"lotId","type":"uint256"}],"name":"completeLot","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"uint256","name":"startTime","type":"uint256"},{"internalType":"uint256","name":"endTime","type":"uint256"},{"internalType":"uint256","name":"step","type":"uint256"},{"internalType":"uint256","name":"startBid","type":"uint256"},{"internalType":"uint256","name":"singlePaymentValue","type":"uint256"}],"name":"createLot","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"tokenUri","type":"string"},{"internalType":"uint256","name":"price","type":"uint256"}],"name":"createMintingRecord","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"uint256","name":"price","type":"uint256"}],"name":"createSaleRecord","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"fee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getFeeReceiver","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"lotId","type":"uint256"}],"name":"getLotData","outputs":[{"internalType":"uint256[]","name":"uintValues","type":"uint256[]"},{"internalType":"address","name":"lastBidSender","type":"address"},{"internalType":"address","name":"owner","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getLotsNumber","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"mintingRecordId","type":"uint256"}],"name":"getMintingRecordData","outputs":[{"internalType":"uint256","name":"price","type":"uint256"},{"internalType":"uint256","name":"accepted","type":"uint256"},{"internalType":"uint256","name":"completed","type":"uint256"},{"internalType":"uint256","name":"cancelled","type":"uint256"},{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"buyer","type":"address"},{"internalType":"string","name":"tokenUri","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getMintingRecordsNumber","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"mintingRecordId","type":"uint256"}],"name":"getNft","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getNftToken","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getPaymentToken","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"saleRecordId","type":"uint256"}],"name":"getSaleRecordData","outputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"uint256","name":"price","type":"uint256"},{"internalType":"uint256","name":"completed","type":"uint256"},{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"buyer","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getSaleRecordsNumber","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"userAddress","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"getUserLotId","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"userAddress","type":"address"}],"name":"getUserLotsNumber","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"userAddress","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"getUserMintingRecordId","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"userAddress","type":"address"}],"name":"getUserMintingRecordsNumber","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"userAddress","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"getUserSaleRecordId","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"userAddress","type":"address"}],"name":"getUserSaleRecordsNumber","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"},{"internalType":"address","name":"paymentToken","type":"address"},{"internalType":"address","name":"nftToken","type":"address"}],"name":"initialize","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"lotId","type":"uint256"}],"name":"lotIsActive","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"mintingRecordId","type":"uint256"}],"name":"mintingRecordIsActive","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"address","name":"from","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"onERC721Received","outputs":[{"internalType":"bytes4","name":"","type":"bytes4"}],"stateMutability":"pure","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"role","type":"string"},{"internalType":"address","name":"userAddress","type":"address"}],"name":"revokeRole","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"saleRecordId","type":"uint256"}],"name":"saleRecordIsActive","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint8","name":"newFee","type":"uint8"}],"name":"setFee","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"feeReceiver","type":"address"}],"name":"setFeeReceiver","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"nftToken","type":"address"}],"name":"setNftToken","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"paymentToken","type":"address"}],"name":"setPaymentToken","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"timestamp","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"tokenUri","type":"string"}],"name":"tokenUriInUse","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}],
        address: '0x831bc94763947fa9e027dc35a9e21cde8dc0a7ab',
    },
    nftToken: {
        abi: [
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "newOwner",
                        "type": "address"
                    },
                    {
                        "internalType": "string",
                        "name": "name",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "symbol",
                        "type": "string"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "approved",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "Approval",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "operator",
                        "type": "address"
                    },
                    {
                        "indexed": false,
                        "internalType": "bool",
                        "name": "approved",
                        "type": "bool"
                    }
                ],
                "name": "ApprovalForAll",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "Transfer",
                "type": "event"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "userAddress",
                        "type": "address"
                    }
                ],
                "name": "addToManagers",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "approve",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    }
                ],
                "name": "balanceOf",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "getApproved",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "operator",
                        "type": "address"
                    }
                ],
                "name": "isApprovedForAll",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "userAddress",
                        "type": "address"
                    }
                ],
                "name": "isManager",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    },
                    {
                        "internalType": "string",
                        "name": "tokenUri",
                        "type": "string"
                    }
                ],
                "name": "mint",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "name",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "owner",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "ownerOf",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "userAddress",
                        "type": "address"
                    }
                ],
                "name": "removeFromManagers",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "safeTransferFrom",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    },
                    {
                        "internalType": "bytes",
                        "name": "_data",
                        "type": "bytes"
                    }
                ],
                "name": "safeTransferFrom",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "operator",
                        "type": "address"
                    },
                    {
                        "internalType": "bool",
                        "name": "approved",
                        "type": "bool"
                    }
                ],
                "name": "setApprovalForAll",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "bytes4",
                        "name": "interfaceId",
                        "type": "bytes4"
                    }
                ],
                "name": "supportsInterface",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "symbol",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "index",
                        "type": "uint256"
                    }
                ],
                "name": "tokenByIndex",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "string",
                        "name": "tokenUri",
                        "type": "string"
                    }
                ],
                "name": "tokenIdByTokenUri",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "index",
                        "type": "uint256"
                    }
                ],
                "name": "tokenOfOwnerByIndex",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "tokenURI",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "totalSupply",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "transferFrom",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "newOwner",
                        "type": "address"
                    }
                ],
                "name": "transferOwnership",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            }
        ],
        address: '0x65c1D4B05960d796F5E8F081F1394D0223C58090',
    },
    paymentToken: {
        abi: [
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "creator",
                        "type": "address"
                    },
                    {
                        "internalType": "string",
                        "name": "name",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "symbol",
                        "type": "string"
                    },
                    {
                        "internalType": "uint256",
                        "name": "supply",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint8",
                        "name": "decimals",
                        "type": "uint8"
                    }
                ],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "spender",
                        "type": "address"
                    },
                    {
                        "indexed": false,
                        "internalType": "uint256",
                        "name": "value",
                        "type": "uint256"
                    }
                ],
                "name": "Approval",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "indexed": false,
                        "internalType": "uint256",
                        "name": "value",
                        "type": "uint256"
                    }
                ],
                "name": "Transfer",
                "type": "event"
            },
            {
                "constant": true,
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "spender",
                        "type": "address"
                    }
                ],
                "name": "allowance",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": false,
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "spender",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "name": "approve",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "account",
                        "type": "address"
                    }
                ],
                "name": "balanceOf",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [],
                "name": "decimals",
                "outputs": [
                    {
                        "internalType": "uint8",
                        "name": "",
                        "type": "uint8"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": false,
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "spender",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "subtractedValue",
                        "type": "uint256"
                    }
                ],
                "name": "decreaseAllowance",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "constant": false,
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "spender",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "addedValue",
                        "type": "uint256"
                    }
                ],
                "name": "increaseAllowance",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [],
                "name": "name",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [],
                "name": "symbol",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [],
                "name": "totalSupply",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": false,
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "recipient",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "name": "transfer",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "constant": false,
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "sender",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "recipient",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "name": "transferFrom",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }
        ],
        address: '0x82473782776675707aF074c4964828EB23cA3b0e',
    },
}

Vue.prototype.$paymentLink = {
    btc: 'https://www.blockchain.com/btc/address/',
    ltc: 'https://live.blockcypher.com/ltc/address/',
    eth: 'https://etherscan.io/address/',
    doge: 'https://dogechain.info/address/',
    xrp: 'https://xrpscan.com/account/',
    bch: 'https://explorer.bitcoin.com/bch/address/',
    usdt: 'https://etherscan.io/address/',
    pax: 'https://etherscan.io/address/',
    trx: 'https://tronscan.org/#/address/',
    xlm: 'https://stellarchain.io/address/',
};

Vue.prototype.formatNumber = (num) => {
    return (num + "").split("").reverse().join("").replace(/(\d{3})/g, "$1 ").split("").reverse().join("").replace(/^ /, "");
};

Vue.prototype.primNum = (string, args = false) => {
    let value;
    if(args !== null) {

        let primSplit = Number(string).toFixed(args + 1).replace(',','.').split('.');

        if(primSplit[1] && primSplit[1].length > args) {
            primSplit[1] = primSplit[1].slice( 0, args);
            value = Number(primSplit[0]+'.'+primSplit[1]);
        } else {
            value = Number(string);
        }
        let val = value.toFixed(args);
        if (val.replace(',','.').split('.')[1] > 0) {
            value = val.replace(/0*$/,"");
        } else if (args > 2 && val.replace(',','.').split('.')[1] == 0) {
            value = Number(val).toFixed(2);
        } else {
            value = val;
        }
        // let sprintf= Math.pow(10, args);
        // value= (Math.round(Number(string) * sprintf) / sprintf).toFixed(args);
    } else {
        let splitValue = string.toLocaleString('en').split(','),
            decimal= '';

        switch (splitValue.length-1) {
            case 1:
                decimal= 'K';
                break;
            case 2:
                decimal= 'M';
                break;
            case 3:
                decimal= 'G';
                break;
            case 4:
                decimal= 'T';
                break;
            case 5:
                decimal= 'P';
                break;
            case 6:
                decimal= 'E';
                break;
            case 7:
                decimal= 'Z';
                break;
            case 8:
                decimal= 'Y';
                break;
        }

        value= splitValue[0]+decimal.toLowerCase();
    }

    return value;
};


Vue.prototype.httpHandler = (response) => {
    if (response.bodyText) {
        response = JSON.parse(response.bodyText);

        Vue.prototype.$checkAuth(response);
        switch (response.status) {
            case 200:
                return response;
            case 401:
            case 403:
                store.commit('updateUserInfo', null);
                location.reload();
                return false;
            case 404:
                routes.push({ name: 'not_found' });
                return false;
        }
        if (response.error && response.error.message instanceof Object) {
            return response;
        } else if (response.error) {
            Vue.notify({
                group: 'message',
                title: response.error.message,
                type: 'error'
            });
        }
    }
    return false;
};
Vue.prototype.$checkAuth= (response) => {
    if(!response.auth && process.env.NODE_ENV === 'production') {
        let auth = store.getters.authUser;
        if(auth) {
            location.reload();
            return false;
        }
    }

    return true;
};

Vue.prototype.validateMessage = {
    required: 'Required',
    integer: 'Integer',
    numeric: 'numeric',
    email: 'EmailError',
    decimal: 'DecimalError',
    minValue: 'minValue :min',
    maxValue: 'maxValue :max',
    minLength: 'minLength :min',
    maxLength: 'maxLength :max',
    sameAsPassword: 'sameAs',
    url: 'urlError',
    sameAsActive: 'sameAsActive',
};

Vue.prototype.getUrlParameter = (name) => {
    name = name.replace(/[\]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};


// Vue.prototype.$socials = ["youtube", "twitch", "twitter", "linkedin", "instagram", "facebook"];
Vue.prototype.$socials = [
    {
        "name": "youtube",
        "icon": "/dist/images/frontend/soc-youtube.svg",
        "url": "https://www.youtube.com/"
    },
    {
        "name": "twitch",
        "icon": "/dist/images/frontend/soc-twitch.svg",
        "url": "https://www.twitch.tv/"
    },
    {
        "name": "twitter",
        "icon": "/dist/images/frontend/soc-twitter.svg",
        "url": "https://twitter.com/"
    },
    {
        "name": "linkedin",
        "icon": "/dist/images/frontend/soc-linkedin.svg",
        "url": "https://www.linkedin.com/"
    },
    {
        "name": "instagram",
        "icon": "/dist/images/frontend/soc-instagram.svg",
        "url": "https://www.instagram.com/"
    },
    {
        "name": "facebook",
        "icon": "/dist/images/frontend/soc-facebook.svg",
        "url": "https://www.facebook.com/"
    }
];
Vue.prototype.$platform = (platform_id) => {
    let platforms = store.getters.platforms;

    let platform = platforms.filter(item => {
        return item.id == platform_id;
    });
    return (platform.length) ? platform[0].platform : null;
};

Vue.prototype.$category = (category_id) => {
    let categories = store.getters.categories;

    let category = categories.filter(item => {
        return item.id == category_id;
    });
    return (category.length) ? category[0].platform : null;
};

Vue.prototype.$changeValidate = (formValidate, validate, type) => {
    if (validate.$invalid) {
        formValidate[type] = [];
        for (var prop in validate.$params) {
            if (!validate[prop]) {
                let msg = Vue.prototype.__(Vue.prototype.validateMessage[prop], validate.$params[prop]);
                formValidate[type].push(msg);
            }
        }
    } else {
        formValidate[type] = null;
    }
    return formValidate;
};
Vue.prototype.$formValidate = (massages, validator) => {
    for (var type in massages) {
        let validate = validator[type];
        if (validate) {
            for (var prop in validate.$params) {
                if (!validate[prop]) {
                    let msg = Vue.prototype.__(Vue.prototype.validateMessage[prop], validate.$params[prop]);
                    massages[type].push(msg);
                }
            }
        }
    }

    return massages;
};

Vue.prototype.$cleanObject = (queryParams) => {
    // const cleanParams = Object.keys(queryParams)
    //     .filter(key => (queryParams[key] != null))
    //     .reduce((acc, key) => Object.assign(acc, { [key]: queryParams[key] }), {});
    return JSON.parse(JSON.stringify(queryParams));
};
Vue.prototype.$filterObject = (queryParams) => {
    return Object.keys(queryParams)
        .filter(key => (queryParams[key] != null))
        .reduce((acc, key) => Object.assign(acc, { [key]: queryParams[key] }), {});
};
Vue.prototype.$cleanArray = (queryParams) => {
    const cleanParams = queryParams.filter(function (x) {
        return x !== undefined && x !== null;
    });
    return cleanParams;
};

Vue.prototype.$renameKeys = (obj, newKeys) => {
    if (obj) {
        if (obj instanceof Array) {
            for (let i = 0; i < obj.length; i++) {
                obj[i] = Vue.prototype.$renameObj(obj[i], newKeys);
            }
        } else {
            obj = Vue.prototype.$renameObj(obj, newKeys);
        }
    }
    return obj;
};
Vue.prototype.$renameObj = (obj, newKeys) => {
    const keyValues = Object.keys(obj).map(key => {
        const newKey = newKeys[key] || key;
        return { [newKey]: obj[key] };
    });

    return Object.assign({}, ...keyValues);
};

Vue.prototype.$minAgo = (data) => {
    let now = moment.utc().format('X');

    let time = Math.round((now - data) / 60);
    let strTime;

    let timeAgo = time;
    if(time >= 518400) {
        strTime = "long";
        timeAgo = null;
    }else if(time >= 43200){
        strTime = "months";
        timeAgo = time/43200;
    }else if(time >= 1440){
        strTime = "days";
        timeAgo = time/1440;
    }else if(time >= 60){
        strTime = "hours";
        timeAgo = time/60;
    } else {
        strTime = "min";
    }
    return ((timeAgo) ? parseInt(timeAgo)+' ' : '') + strTime;
};

Vue.prototype.$timeAgo = (data) => {
    let now = moment.utc().format('X');
    time = moment.utc(data).format('X');

    let time = Math.round((now - time) / 60);
    let strTime;

    if(time >= 10080) {
        strTime = moment.utc(data).format('DD.MM.YY');
    }else if(time >= 1440){
        strTime = moment.utc(data).format('MMM');
    }else {
        strTime = moment.utc(data).format('H:mm');
    }
    return strTime;
};
Vue.prototype.$timeFormatted = (timestamp) => {

    let hours = Math.floor(timestamp / 60 / 60);
    let minutes = Math.floor(timestamp / 60) - (hours * 60);
    let seconds = timestamp % 60;

    let time = [];


    if (hours) {
        time.push(hours);
    }
    time.push(minutes.toString().padStart(2, '0') + ' minutes');
    time.push(seconds.toString().padStart(2, '0') + ' seconds');


    return time.join(' ');
};

Vue.prototype.$launchFullScreen = (element_id) => {
    let element = document.getElementById(element_id);
    if (element.requestFullScreen) {
        element.requestFullScreen();
    } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
    } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
    }
};
Vue.prototype.$socket = () => {
    let auth = store.getters.authUser;

    Vue.prototype.$echo.connector.socket.on('connect', () => {
        store.dispatch("asyncConnect", 'connect');
    });
    Vue.prototype.$echo.connector.socket.on('disconnect', () => {
        store.dispatch("asyncConnect", 'disconnect');
    });
    Vue.prototype.$echo.connector.socket.on('reconnecting', () => {
        store.dispatch("asyncConnect", 'reconnecting');
    });

    return Vue.prototype.$echo.join('play.' + auth.session_id);
};

Vue.prototype.$cancelFullscreen = () => {
    if (document.cancelFullScreen) {
        document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
    }
};
Vue.prototype.$path = (process.env.NODE_ENV === 'production') ? Vue.prototype.$APP_URL + '/' : 'http://localhost:3000/';
Vue.prototype.$token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');


Vue.prototype.$filterArray = (array, value, key = 'id') => {
    let filter= {};

    if (value instanceof Array) {

        filter= value;
    } else {
        filter[key]= value;
    }

    return _.find(array, filter)
    // let arr = array.filter(item => {
    //     if (value instanceof Array) {
    //         let check = true;
    //         for (let x = 0; x < value.length; x++) {
    //             let attr = value[x],
    //                 condition;
    //             switch (attr.operator) {
    //                 case '!=':
    //                         condition = item[attr.key] == attr.value;
    //                     break;
    //                 default:
    //                     condition = item[attr.key] != attr.value;
    //             }
    //             if (condition) {
    //                 return false
    //             }
    //         }
    //         return check;
    //     } else {
    //         return item[key] == value;
    //     }
    // });
    // return (arr.length) ? arr[0] : null;
};

Vue.prototype.$filterIndexObject = (objects, value, key = 'id') => {
    if (objects instanceof Object) {
        return objects.map(function (e) { return String(e[key]); }).indexOf(String(value));
    } else {
        return null;
    }
};
Vue.prototype.$filterIndexArray = (objects, value) => {
    if (Array.isArray(objects)) {
        return objects.map(function (e) { return String(e); }).indexOf(String(value));
    } else {
        return null;
    }
};

Vue.prototype.$sortObject = (array, key) => {
    return array.sort(function (a, b) {
        return a[key] - b[key]
    })
};

Vue.prototype.$inviteTimer = 15;
Vue.prototype.$timeRematch = 15;

Vue.prototype.$leaveWebsocket = ()=> {
    let auth = store.getters.authUser;
    store.dispatch("asyncInviteGame", []);
    Vue.prototype.$echo.leave('play.' + auth.session_id);
    // let response= {
    //     user_id: auth.id,
    // };
    //
    // this.$http.post("ajax/games/cancel_invite", response)
    // .then((val) => {
    //     console.log(val);
    // })
    // .then((response) => {
    //     return response.json();
    // })
    // .catch((err) => {
    //     this.httpHandler(err);
    // });
};

Vue.prototype.$sendNotification = (title, options)=> {
    // Проверим, поддерживает ли браузер HTML5 Notifications
    if (!("Notification" in window)) {
        console.log('Ваш браузер не поддерживает HTML Notifications, его необходимо обновить.');
    } else if (Notification.permission === "granted") { // Проверим, есть ли права на отправку уведомлений
        // Если права есть, отправим уведомление
        new Notification(title, options);
    } else if (Notification.permission !== 'denied') { // Если прав нет, пытаемся их получить
        Notification.requestPermission(function (permission) {
            // Если права успешно получены, отправляем уведомление
            if (permission === "granted") {
                new Notification(title, options);
            } else {
                console.log('Вы запретили показывать уведомления'); // Юзер отклонил наш запрос на показ уведомлений
            }
        });
    } else {
        // Пользователь ранее отклонил наш запрос на показ уведомлений
        // В этом месте мы можем, но не будем его беспокоить. Уважайте решения своих пользователей.
    }
};
Vue.prototype.$connectNotification = ()=> {
    let auth = store.getters.authUser;
    Vue.prototype.$echo.join('notification.' + auth.session_id)
        .listen("ChatEvent", (response) => {
            response= response.data;

            function checkUserList(users_list) {
                let indexList= Vue.prototype.$filterIndexObject(users_list.data, response.to, 'to');
                if(indexList >= 0) {
                    users_list.data.splice(indexList, 1);
                    users_list.data.unshift(response.users_list);
                } else {
                    users_list.data.unshift(response.users_list);
                    users_list.total += 1;
                }
                return users_list;
            }

            if(response.users_list) {
                let users_list= Vue.prototype.$cleanObject(store.getters.users_list) ;
                if(users_list) {
                    users_list= checkUserList(users_list);
                    store.dispatch("asyncUsersList", users_list);
                }


                let modal_users_list= Vue.prototype.$cleanObject(store.getters.modal_users_list) ;
                if(modal_users_list) {
                    modal_users_list= checkUserList(modal_users_list);

                    store.dispatch("asyncModalUsersList", modal_users_list);
                }
            }

            if(response.count >= 0) {
                store.dispatch("asyncMessagesCount", response.count);
                // try {
                //     new Audio('/assets/media/MSG_MP.mp3').play();
                // } catch ($e) {
                //     console.error($e);
                // }
            }

            store.dispatch("asyncMessage", response.message);
        }).listen('FriendEvent', (response)=> {
        response= response.data;
        if(response.data) {
            store.dispatch("asyncFriendsReq", response.data);

            if(response.data.type) {
                store.dispatch("asyncPushNotice", response.data);
            }
        }
        if(response.friends >= 0) {
            store.dispatch("asyncFriendsReqCount", response.friends);
        }
    }).listen('BalanceEvent', (response)=> {
        store.dispatch("asyncUpdateUserBalance", response.data);
    }).listen('AchievementEvent', (response)=> {
        store.dispatch("asyncPushNotice", response.data);
    }).listen('QuestEvent', (response)=> {
        store.dispatch("asyncPushNotice", response.data);
    }).listen('publicEvent', (response)=> {
        store.dispatch("asyncPushNotice", response.data);

    });

    Vue.prototype.$echo.join('notice')
        .listen('PublicEvent', (response)=> {
            if(response.data.notice == 'news') {
                store.dispatch("asyncPushNotice", response.data);

            } else if (response.data.notice == 'ready') {
                if (response.data.user_active) {

                    let array_sleep = Vue.prototype.$cleanObject(store.getters.getReadyToPlay);
                    array_sleep[response.data.user_id] = response.data.user_active;
                    store.dispatch("asyncReadyToPlay", array_sleep);

                    if (response.data.user_active == 1 && response.data.user_id == store.state.auth.user.id) {
                        store.commit('updateReadyPlay', 0);
                    }


                } else {
                    let array_sleep = Vue.prototype.$cleanObject(store.getters.getReadyToPlay);

                    if(response.data.user_id == store.state.auth.user.id) {
                        store.commit('updateReadyPlay', 1);
                    }
                    if (array_sleep[response.data.user_id]) {
                        delete array_sleep[response.data.user_id];
                    }
                    store.dispatch("asyncReadyToPlay", array_sleep);
                }
            } else if (response.data.notice == 'chat_public') {
                let chat = Vue.prototype.$cleanObject(store.getters.getChatPublic);
                chat.push(response.data.data);

                store.dispatch("asyncChatPublic", chat);
                store.dispatch("asyncCountOnline", response.data.data.count_online);
            } else if (response.data.notice == 'chat_public_delete') {
                let chat = Vue.prototype.$cleanObject(store.getters.getChatPublic);
                let filter_chat = chat.filter(item => item.id != response.data.data.id);

                store.dispatch("asyncChatPublic", filter_chat);
            }
        });
};

Vue.prototype.$connectWebsocket = ()=> {
    Vue.prototype.$socket()
        .listen("InviteGame", (data) => {
            let response= data.data;
            store.dispatch("asyncPushInviteGame", response);
            Vue.prototype.$sendNotification(response.game_name, {
                body: ((response.wallet== 1) ? 'Real Coin:' : 'Lite Coin')+" "+response.amount,
                dir: 'auto',
                renotify: true,
                silent: true,
                tag: response.match_id,
                icon: '/assets/games/'+response.game_logo
            });
            // try {
            //     new Audio('/assets/media/battle-city-sfx-12.mp3').play();
            // } catch ($e) {
            //     console.error($e);
            // }

            new Howl({
                src: ['/assets/media/battle-city-sfx-12.mp3'],
            }).play();


            if (store.state.auth.user.id == 739165517) {
                if ('Notification' in window) {
                    // Проверяем, имеет ли пользователь разрешение на отправку уведомлений
                    if (Notification.permission === 'granted') {
                        // Если разрешение есть, можно отправлять уведомления
                        Push.create('TEST 123', {
                            body: 'qwerty121212',
                            // url: 'https://dstarod.github.io/idea-trial/',
                            icon: '/assets/games/'+response.game_logo,
                            timeout: 10000,
                            // onClick: function () {
                            //     window.focus();
                            //     this.close();
                            // }
                        });
                    } else {
                        // Если разрешения нет, запросим его у пользователя
                        Notification.requestPermission().then((permission) => {
                            if (permission === 'granted') {
                                // Если пользователь дал разрешение, можно отправлять уведомления
                                Push.create('TEST 123', {
                                    body: 'qwerty121212',
                                    // url: 'https://dstarod.github.io/idea-trial/',
                                    icon: '/assets/games/'+response.game_logo,
                                    timeout: 10000,
                                    // onClick: function () {
                                    //     window.focus();
                                    //     this.close();
                                    // }
                                });
                            }
                        });
                    }
                }
            }

            // let sound = new Howl({
            //     src: ['/assets/media/battle-city-sfx-12.mp3', 'sound.mp3'],
            //     onplayerror: function() {
            //         sound.once('unlock', function() {
            //             sound.play();
            //         });
            //     }
            // });
            // sound.play();
        })
        .listen("StartGame", (data) => {
            data= data.data;
            store.dispatch("asyncModalInvite", null);
            if (data.room_id) {
                routes.push({
                    name: "frame",
                    params: {
                        id: data.game_url,
                        room_id: data.room_id,
                        battle_id: data.battle_id,
                    },
                });
            }
        })
        .listen("CancelGame", (data) => {
            let invite_game = store.state.games.invite_game;
            let index = Vue.prototype.$filterIndexObject(
                invite_game,
                data.data.auth_id,
                "inviter_id"
            );
            if (index >= 0) {
                invite_game.splice(index, 1);
                store.dispatch("asyncInviteGame", invite_game);
            }

            let modal_invite = store.state.games.modal_invite;
            if (modal_invite && modal_invite.user_id==  data.data.auth_id) {
                modal_invite.cancel= true;

                store.dispatch("asyncModalInvite", modal_invite);
            }
        });

    return true;
};



Vue.prototype.$isEmpty = (obj)=> {
    for (let key in obj) {
        // если тело цикла начнет выполняться - значит в объекте есть свойства
        return true;
    }
    return false;
};

var _eventHandlers = {};

Vue.prototype.$addListener = (node, event, handler, capture= false)=> {
    Vue.prototype.$removeAllListeners(node,'scroll');

    if(!(node in _eventHandlers)) {
        // _eventHandlers stores references to nodes
        _eventHandlers[node] = {};
    }
    if(!(event in _eventHandlers[node])) {
        // each entry contains another entry for each event type
        _eventHandlers[node][event] = [];
    }
    // capture reference
    _eventHandlers[node][event].push([handler, capture]);
    node.addEventListener(event, handler, capture);
};
Vue.prototype.$removeAllListeners = (node, event)=> {
    if(node in _eventHandlers) {
        var handlers = _eventHandlers[node];
        if(event in handlers) {
            var eventHandlers = handlers[event];
            for(var i = eventHandlers.length; i--;) {
                var handler = eventHandlers[i];
                node.removeEventListener(event, handler[0], handler[1]);
            }
        }
    }
};

Vue.prototype.$random = (arr)=> {
    return Math.floor(Math.random()*(arr));
};

Vue.prototype.$copyMessage = (copy)=> {
    let body = document.getElementsByTagName('body')[0];
    let tempInput = document.createElement('INPUT');
    body.appendChild(tempInput);
    tempInput.setAttribute('value', copy);
    tempInput.select();
    document.execCommand('copy');
    body.removeChild(tempInput);
};


Vue.prototype.$toTime = (timestamp)=> {
    let hours = Math.floor(timestamp / 60 / 60);
    let minutes = Math.floor(timestamp / 60) - (hours * 60);
    let seconds = timestamp % 60;

    let formatted= [];

    if(hours) {
        formatted.push(hours.toString().padStart(2, '0'));
    }
    formatted.push(minutes.toString().padStart(2, '0'));
    formatted.push(seconds.toString().padStart(2, '0'));

    return formatted.join(':');
};


Vue.filter('endTime', function(value) {
    return value;
});